module.exports = __webpack_public_path__ + "25ec3ae98a1e6bd80887e1fb2e654e25.svg";